import { useCallback } from 'react';

import { defineMessages, useIntl } from 'react-intl';

import { switchableAccountIds } from 'mastodon/initial_state';
import { logOut } from 'mastodon/utils/log_out';

import type { BaseConfirmationModalProps } from './confirmation_modal';
import { ConfirmationModal } from './confirmation_modal';

const messages = defineMessages({
  logoutTitle: { id: 'confirmations.logout.title', defaultMessage: 'Log out?' },
  logoutMessage: {
    id: 'confirmations.logout.message',
    defaultMessage: 'Are you sure you want to log out?',
  },
  logoutConfirm: {
    id: 'confirmations.logout.confirm',
    defaultMessage: 'Log out',
  },
  logoutAll: {
    id: 'confirmations.logout.all_accounts',
    defaultMessage: 'Log out of all accounts in this browser',
  },
});

export const ConfirmLogOutModal: React.FC<BaseConfirmationModalProps> = ({
  onClose,
}) => {
  const intl = useIntl();

  const onConfirm = useCallback(() => {
    void logOut();
  }, []);

  const onLogOutAll = useCallback(() => {
    void logOut({ allAccounts: true });
  }, []);

  // Offered when other accounts are remembered for switching, e.g. on a
  // shared computer
  const hasOtherAccounts = switchableAccountIds.length > 0;

  return (
    <ConfirmationModal
      title={intl.formatMessage(messages.logoutTitle)}
      message={intl.formatMessage(messages.logoutMessage)}
      confirm={intl.formatMessage(messages.logoutConfirm)}
      onConfirm={onConfirm}
      secondary={
        hasOtherAccounts ? intl.formatMessage(messages.logoutAll) : undefined
      }
      onSecondary={hasOtherAccounts ? onLogOutAll : undefined}
      onClose={onClose}
    />
  );
};
